<template>
	<basic-container>
		<div class="box">
			<div class="box_left">
				<div class="box_left_top">
					<div class="mark"><img :src="require('@/assets/img/mark.png')" alt="">
						<span class="markText">8</span>
					</div>
				</div>
				<div style="text-align: center;"><span
						style="font-weight: bold;color: #000;text-align: center;font-family: PingFang-SC-Regular;">Metrics</span>
				</div>
				<div class="box_left_middle">
					<p
						style="padding: 15px 0px;margin:0px;text-align: center;background-color: hsl(228deg, 45.45%, 97.84%);">
						Citation Distribution <span class="question0" data-title="This is the total number of times a publication has been cited. We count citations from
						the reference list in all publications that have been indexed by Dimensions."><img class="question"
								:src="require('@/assets/img/question.png')" alt=""></span></p>
					<div class="citation_block">
						<div class="citation_block1">
							<div style="height: 6px; background-color: #5e33bf;"></div>
							<div style="border-bottom: 1px solid #f5f1f1;color: #5e33bf;font-weight: bold">W</div>
							<div>1</div>
						</div>
						<div class="citation_block1">
							<div style="height: 6px; background-color: #ff8200;"></div>
							<div style="border-bottom: 1px solid #f5f1f1;color: #ff8200;font-weight: bold">S</div>
							<div>1</div>
						</div>
						<div class="citation_block1">
							<div style="height: 6px; background-color: #1da6b8;"></div>
							<div style="border-bottom: 1px solid #f5f1f1;font-weight: bold"><img
									:src="require('@/assets/img/c.png')" alt=""></div>
							<div>1</div>
						</div>
						<div class="citation_block1">
							<div style="height: 6px; background-color:#e5e5e5;"></div>
							<div style="border-bottom: 1px solid #f5f1f1;font-weight: bold">N</div>
							<div>1</div>
						</div>
					</div>
				</div>
				<div class="box_left_bottom">
					<div class="box_left_bottom_text">Generate Citation Report</div>
				</div>
			</div>
			<div class="box-right">
				<div class="box-right-top">
					<p>Emotional Processing As A Function Of Different Probabilistic Contexts: A High-density Eeg
						investigation</p>
					<div style="display: flex;justify-content: space-between;">
						<div class="text_left">
							<p><span class="first">Publication:</span><span class="second_text"> Article in <span
										style="font-weight: bold;color: #000;">Current Medicinal Chemistry</span>,
									published January 2022</span></p>
							<p><span class="first">Orcid:</span><span class="second_text"> 0000-0002-7661-0521</span>
							</p>
							<p><span class="first">Author:</span><span class="second_text"> Sirajo Murtala, Mohammed
									lbrahim, Sagir Lawal and Buhari Baba Abdullah</span></p>
							<p><span class="first">DOI:</span><span
									class="second_text">https://doi.org/10.1186/s12898-020-00337-z</span></p>
						</div>
						<div class="text-right">
							<div>Citation Alerts Subscription</div>
							<div>
								<p
									style="margin-bottom:5px;font-family: PingFang-SC-Bold;font-size: 20px;font-weight: normal;font-stretch: normal;line-height: 26px;letter-spacing: 0px;color: #010101;">
									Share this page</p>
								<div style='display: flex;justify-content: space-between;width: 149px;'>
									<img :src="require('@/assets/img/index_03.png')" alt=""><img
										:src="require('@/assets/img/index_05.png')" alt="">
									<img :src="require('@/assets/img/index_07.png')" alt=""><img
										:src="require('@/assets/img/index_09.png')" alt="">
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="box-right-bottom">
					<el-tabs class="tab" type="border-card">
						<el-tab-pane label="Geographical Views">
							<div style="margin:20px 0px;"><span
									style="border:2px solid #01395a;padding:8px 0px;"></span><span
									style="background-color:hsl(228deg, 45.45%, 97.84%);padding:10px 0px 10px 4px;width:101%;display: inline-block;">
									Contrimetric has found a total of <span style="font-weight: bold;">8</span>
									citations of this research output, All as shown below.</span></div>
							<!-- <div id="map" style="width: 800px;height:500px;"></div> -->


							<div class="worldEchart-page">
								<div id="map" style="width: 954px;height: 446px;">
								</div>
							</div>
						</el-tab-pane>
						<el-tab-pane label="Summary">
							<div style="summary_text">

								<div style="margin:20px 0px;"><span
										style="border:2px solid #01395a;padding:8px 0px;"></span><span
										style="background-color:hsl(228deg, 45.45%, 97.84%);padding:10px 0px 10px 4px;width:101%;display: inline-block;">
										This is the public page for a publication record in <span
											style="color:#004b6d">influence</span>,a free research insights plattform
										that brings together information about funding,scholarly outputs,policy,parents
										and grants.</span></div>
								<div style="margin-left:34px;">
									<p>This publication in Current Medicinal Chemistry has been cited 9 times, 88% of
										its citations have been received in the past two vears.</p>
									<p>Compared to other publications in the same feld, this publication is hiahw citeed
										approximately 4.03 times more citations than average.</p>
									<p>You are seeing a free-to-access but limited selection of the activity
										Contrimetric has collected about this research output. <span
											style="color:#409EFF;cursor: pointer;">Click here to find out more.</span>
									</p>
								</div>
							</div>
							<div style="display: flex;justify-content: space-between;margin:73px 0px;">
								<div class="b"><img :src="require('@/assets/img/w.png')" alt="">
									<div class="block_text"><span class="block_text1">3</span><br>
										<span>Citations</span>
									</div>
								</div>
								<div class="b"><img :src="require('@/assets/img/s.png')" alt="">
									<div class="block_text"><span class="block_text1">3</span><br>
										<span>Citations</span>
									</div>
								</div>
								<div class="b"><img :src="require('@/assets/img/c1.png')" alt="">
									<div class="block_text"><span class="block_text1">3</span><br>
										<span>Citations</span>
									</div>
								</div>
								<div class="b"><img :src="require('@/assets/img/n.png')" alt="">
									<div class="block_text"><span class="block_text1">3</span><br>
										<span>Citations</span>
									</div>
								</div>

							</div>
						</el-tab-pane>
						<el-tab-pane label="Peridical Views">
							<div style="margin:20px 0px;"><span
									style="border:2px solid #01395a;padding:8px 0px;"></span><span
									style="background-color:hsl(228deg, 45.45%, 97.84%);padding:10px 0px 10px 4px;width:101%;display: inline-block;">
									This page displays the distribution of traffic sources for this paper on that day.
								</span></div>
							<div class="peridicalView">
								<div>
									<h4>Daliy View</h4>
									<div class='peridicalViewTop'>
										<div class="first2">
											<div>158</div>
											<div class="first0">Page View(PV)</div>
										</div>
										<div class="first2">
											<div>150</div>
											<div class="first0">Internet Protocoll(IPS)</div>
										</div>
										<div class="first2">
											<div>602</div>
											<div class="first0">Unique Visitor(UV)</div>
										</div>
										<div class="first2">
											<div>00:01:13</div>
											<div class="first0">Average Time on Site</div>
										</div>

									</div>
									<div>
										<div id="peridicalView" style="width: 954px;height: 546px;"></div>
									</div>
								</div>
								<div></div>
								<div></div>
								<div></div>
							</div>



						</el-tab-pane>
						<el-tab-pane label="Favorites">

							<div style="margin:20px 0px;"><span
									style="border:2px solid #01395a;padding:8px 0px;"></span><span
									style="background-color:hsl(228deg, 45.45%, 97.84%);padding:10px 0px 10px 4px;width:101%;display: inline-block;">
									<!-- Contrimetric has found a total of <span style="font-weight: bold;">8</span>
									citations of this research output, All as shown below. -->

									The author's email who loves this paper.
								</span></div>
							<div style="margin-left:34px;" v-for="(item,index) in articleItem" :key="index">
								<div class="article_fame">
									<div class="article_fame_left"><img :src=item.avatar alt=""></div>
									<div class="article_fame_right">
										<div style='width: 3%;'><img src='../../assets/img/email.png' alt=""
												style="width: 75%;"></div>
										<div>
											<div style="font-size: 18px;">{{item.item}}</div>
											<div><b>Article in：</b><span style='color:#5e5e5e'>{{item.item1}}</span>
											</div>
										</div>

									</div>
								</div>
								<!-- <div class="article1_fame">
									<div class="article1_fame_right">
										<img src="" alt=""><img src="" alt=""><img src="" alt=""><img src="" alt="">
									</div>
								</div> -->

							</div>
							<div style="margin:60px 0px;display: flex;justify-content: right;">
								<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
									:current-page="currentPage4" :page-sizes="[10, 20, 30, 40]" :page-size="100" small
									layout="prev, pager, next" :total="400">
								</el-pagination>
							</div>

						</el-tab-pane>
						<el-tab-pane label="Citations">
							<div v-if="jianshe">
								<div style="margin:20px 0px;"><span
										style="border:2px solid #01395a;padding:8px 0px;"></span><span
										style="background-color:hsl(228deg, 45.45%, 97.84%);padding:10px 0px 10px 4px;width:101%;display: inline-block;">
										Contrimetric has found a total of <span style="font-weight: bold;">8</span>
										citations of this research output, All as shown below.</span></div>
								<div style="margin-left:34px;" v-for="(item,index) in articleItem" :key="index">
									<div class="article_block">
										<div>{{item.item}}</div>
										<div><span style='color:#5e5e5e'>Article in</span>{{item.item1}}</div>
									</div>

								</div>
								<div style="margin:60px 0px;display: flex;justify-content: right;">
									<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
										:current-page="currentPage4" :page-sizes="[10, 20, 30, 40]" :page-size="100"
										small layout="prev, pager, next" :total="400">
									</el-pagination>
								</div>
								<div id="main" style="width: 800px;height:500px;"></div>
							</div>
							<div v-else>
								<div style="text-align: center;">The website is under construction!</div>
							</div>
						</el-tab-pane>




					</el-tabs>
				</div>
			</div>
		</div>
	</basic-container>
</template>

<script>
	import * as echarts from 'echarts';
	import
	worldJson
	from "@/assets/json/world.json";

	import
	linshiJson
	from "@/assets/json/new_file.json";

	export default {
		name: 'index',
		data() {
			return {
				articleItem: [{
						item: 'sdsfdsfsdfsdfsdfsdfwercvzxczxcwqe',
						item1: '11sdsfdsfsdfsdfsdfsdfwercvzxczxcwqe',
						avatar: require('@/assets/img/avatar.png'),

					},
					{
						item: 'sdsfdsfsdfsdfsdfsdfwercvzxczxcwqe',
						item1: '11sdsfdsfsdfsdfsdfsdfwercvzxczxcwqe',
						avatar: require('@/assets/img/avatar.png'),

					}
				], //论文数据
				currentPage4: 1,
				jianshe: false,


			}
		},
		mounted() {


			let ob = {}
			worldJson.features.forEach((it, index) => {
				ob[it.properties.name] = index
			})

			console.log(JSON.stringify(ob))

			this.geography()
			this.getPeridicalViewTop()



		},
		methods: {
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			},
			geography() {
				var chartDom = document.getElementById('map');
				var myChart = echarts.init(chartDom);
				var option;

				myChart.showLoading();

				myChart.hideLoading();
				echarts.registerMap('world', worldJson);
				option = {
					title: {
						text: 'World',
						subtext: '副标题',
						sublink: '副标题链接',
						left: 'right'
					},
					tooltip: {
						// trigger: 'item',
						// showDelay: 0,
						// transitionDuration: 0.2,
						trigger: 'item',
						padding: 0,
						enterable: true,
						transitionDuration: 1,
						textStyle: {
							color: '#818A91',
							decoration: 'none',
						},
						backgroundColor: 'rgba(255,255,255,0.96)',


					},
					visualMap: {
						type: 'piecewise',
						// splitNumber:5, //对于连续型数据，自动平均切分成几段。默认为5段
						hoverLink: false,
						itemWidth: 12, //图形的宽度，即长条的宽度。
						itemHeight: 12, //图形的高度，即长条的高度。	
						textStyle: { //文本样式
							color: '#777F86'
						},
						bottom: 15, // 组件离容器下侧的距离
						pieces: [ //自定义『分段式视觉映射组件（visualMapPiecewise）』的每一段的范围，以及每一段的文字，以及每一段的特别的样式
							{
								min: 1500,
								label: '出口额占比75-100%',
								color: '#3267D7'
							}, // 不指定 max，表示 max 为无限大（Infinity）。
							{
								min: 900,
								max: 1500,
								label: '出口额占比50-75%',
								color: '#1681F0'
							},
							{
								min: 310,
								max: 1000,
								label: '出口额占比25-50%',
								color: '#41ABFF'
							},
							{
								min: 0,
								max: 300,
								label: '出口额占比1-25%',
								color: '#A3CBFF'
							},
							//{max: 0,label:'无数据',color:'#EDEDED'}
							{
								value: 0,
								label: '无数据',
								color: '#EDEDED'
							}, // 表示 value 等于 123 的情况。
							// 不指定 min，表示 min 为无限大（-Infinity）。
						]



						// left: 'right',
						// min: 500000,
						// max: 38000000,
						// inRange: {
						// 	color: [
						// 		'#313695',
						// 		'#4575b4',
						// 		'#74add1',
						// 		'#abd9e9',
						// 		'#e0f3f8',
						// 		'#ffffbf',
						// 		'#fee090',
						// 		'#fdae61',
						// 		'#f46d43',
						// 		'#d73027',
						// 		'#a50026'
						// 	]
						// },
						// text: ['High', 'Low'],
						// calculable: true
					},
					toolbox: {
						show: true,
						//orient: 'vertical',
						left: 'left',
						top: 'top',
						feature: {
							dataView: {
								readOnly: false
							},
							restore: {},
							saveAsImage: {}
						}
					},
					series: [{
						name: 'world',
						type: 'map',
						roam: true,
						map: 'world',
						emphasis: {
							label: {
								show: true
							}
						},
						data: [{
								name: 'China',
								value: 4822023,
							},
							{
								name: 'Somalia',
								value: 18,
							}
						]
					}]
				};
				myChart.setOption(option);


				option && myChart.setOption(option);

			},
			getPeridicalViewTop() {
				var chartDom = document.getElementById('peridicalView');
				var myChart = echarts.init(chartDom);
				var option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
							label: {
								backgroundColor: '#6a7985'
							}
						}
					},
					grid: {
						bottom: '10%',
					},
					xAxis: [{
						type: 'value',
						boundaryGap: false,
					}],

					legend: {
						bottom: 0,
						orient: 'horizontal',
						data: ['邮件营销', '邮件营销']
					},
					yAxis: [{
						type: 'value'
					}],
					series: [{
							name: '邮件营销',
							type: 'line',
							stack: '总量',
							itemStyle: {
								normal: {
									areaStyle: {
										type: 'default',
										//渐变色实现===
										color: new echarts.graphic.LinearGradient(0, 0, 0, 1,
											//三种由深及浅的颜色
											[{
												offset: 0,
												color: 'green'
											}, {
												offset: 1,
												color: '#ffffff'
											}]),
									},
									lineStyle: { //线的颜色
										color: 'green'
									},
									//以及在折线图每个日期点顶端显示数字
									label: {
										show: true,
										position: 'top',
										textStyle: {
											color: 'white'
										}
									},

								},
							},
							areaStyle: {},
							data: [1.4, 2.32, 3.01, 4.134, 5.9, 6.30, 7.10]
						},
						{
							name: '邮件营销',
							type: 'line',
							stack: '总量',
							itemStyle: {
								normal: {
									areaStyle: {
										type: 'default',
										//渐变色实现===
										color: new echarts.graphic.LinearGradient(0, 0, 0, 1,
											//三种由深及浅的颜色
											[{
												offset: 0,
												color: '#a5ffc2'
											}, {
												offset: 1,
												color: '#ffffff'
											}]),
									},
									lineStyle: { //线的颜色
										color: '#a5ffc2'
									},
									//以及在折线图每个日期点顶端显示数字
									label: {
										show: true,
										position: 'top',
										textStyle: {
											color: 'white'
										}
									}
								},
							},
							areaStyle: {},
							data: [1.9, 2.2, 3.01, 3.4, 4.0, 4.30, 5.10]
						},
					]
				};

				option && myChart.setOption(option);
			}

		}
	}
</script>
<style lang="scss" scoped>
	.box {
		padding: 43px 58px 0px 24px;
		display: flex;
		background-color: hsl(228deg, 45.45%, 97.84%);
	}

	.box_left {
		width: 18%;
		margin-right: 5px;
	}

	.mark {
		text-align: center;
		position: relative;
	}

	.markText {
		font-weight: bold;
		color: black;
		position: absolute;
		top: 50%;
		/* 根据需要调整垂直位置，可以使用百分比 */
		left: 50%;
		/* 根据需要调整水平位置，可以使用百分比 */
		transform: translate(-50%, -50%);
		/* 将数字居中定位 */
	}


	// logo旋转效果
	.mark>img {
		width: 50%;
		transform-origin: center;
		/* 设置动画效果 */
		animation: rotateAnimation 60s infinite linear;
	}

	/* 定义旋转动画 */
	@keyframes rotateAnimation {
		from {
			transform: rotate(0deg);
		}

		to {
			transform: rotate(360deg);
		}
	}


	.box_left_middle {
		margin-top: 15px;
	}

	.question {
		width: 18px;
		height: 18px;
	}

	.question0 {
		position: relative;
	}

	.question0:hover:after {
		position: absolute;
		bottom: 2rem;
		left: -14rem;
		width: 16rem;
		font-size: 0.675rem;
		content: attr(data-title);
		padding: 17px 10px 17px 10px;
		border: 1px solid #d4d4d6;
		border-radius: 5px;
		background-color: black;
		hyphens: auto;
		text-align: justify;
		text-indent: 0;
		color: #ffffff;
		z-index: 10000;
	}

	.box_left_middle {
		background-color: #fff;
		box-shadow: 3px 3px 12px 0px rgba(228, 228, 228, 0.5);
		margin-bottom: 60px;
	}

	.citation_block {
		display: flex;
	}

	.citation_block1 {
		flex: 1;
		border: 1px solid #f5f1f1;
		border-right: 0px;
	}

	.citation_block1>div:nth-child(2) {
		padding: 5px 0px;
		text-align: center;
	}

	.citation_block1>div:last-child {
		padding: 5px 0px;
		text-align: center;
	}

	.box_left_bottom {
		display: flex;
		justify-content: center;
	}

	.box_left_bottom_text {
		width: 266px;
		text-align: center;
		padding: 18px 10px;
		background-image: linear-gradient(0deg,
				#d7d7d7 0%,
				#ffffff 100%),
			linear-gradient(#01395a,
				#01395a);
		background-blend-mode: normal,
			normal;
		border-radius: 11px;
		border: solid 1px #01395a;
		font-family: PingFang-SC-Bold;
		letter-spacing: 0px;
		color: #01395a;
	}


	.box-right {
		flex: 1;
		padding: 0px 10px 0px 5px;
	}

	.box-right-top>p {
		margin: 0px;
		margin-bottom: 30px;
		font-family: PingFang-SC-Bold;
		font-size: 26px;
		font-weight: normal;
		font-stretch: normal;
		line-height: 26px;
		letter-spacing: 0px;
		color: #000000;
	}

	.first {
		font-family: PingFang-SC-Bold;
		font-size: 16px;
		font-weight: normal;
		font-stretch: normal;
		line-height: 26px;
		letter-spacing: 0px;
		color: #535353;
	}

	.second_text {
		font-family: PingFang-SC-Regular;
		font-size: 16px;
		font-weight: normal;
		letter-spacing: 0px;
		color: #a8a8a8;
	}

	.text_left>p {
		margin: 5px;
	}

	.text-right>div:nth-child(1) {
		padding: 15px 10px;
		background-color: #01395a;
		border-radius: 11px;
		font-family: PingFang-SC-Bold;
		font-size: 20px;
		font-weight: normal;
		font-stretch: normal;
		line-height: 26px;
		letter-spacing: 0px;
		color: #f6f8fc;
		text-align: center;
	}

	.box-right-bottom {
		margin: 20px 0px;
	}

	.tab {
		padding: 25px 0px 0px 0px;
	}

	// 修改tab
	::v-deep .el-tabs--border-card>.el-tabs__header {
		background-color: #fff;
	}

	::v-deep .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
		background-color: hsl(228deg, 45.45%, 97.84%);
		color: #01395a;
	}

	.summary_text>p {
		font-size: 14px;
	}

	.b {
		position: relative;
	}

	.block_text {
		position: absolute;
		color: #ffffff;
		top: 12px;
		left: 120px;
	}

	.block_text1 {
		font-weight: bold;
		font-size: 48px;
	}

	.article_block {
		padding: 15px 10px;
		border-bottom: 1px solid #e5e5e5;
	}

	.article_fame {
		padding: 15px;
		display: flex;
		justify-content: center;
		border-bottom: 1px solid #e5e5e5;


	}

	.article1_fame {
		border-bottom: 1px solid #e5e5e5;

	}

	.article_fame_left {
		width: 8%;
	}

	.article_fame_left>img {
		width: 80px;
		height: 80px;
		border-radius: 50%;
	}

	.article_fame_right {
		flex: 1;
		display: flex;
		margin-top: 13px;
	}

	.article1_fame_right {
		margin-left: 140px;
	}

	.article1_fame_right>img {
		width: 45px;
		height: 45px;
		border: 1px solid black;
		margin-right: 30px;

	}

	.peridicalView {
		display: flex;
		flex-direction: column;
	}

	.peridicalView>div>h4 {
		color: #01395a;
	}

	.peridicalView>div {
		margin: 30px 0;
		padding-bottom: 40px;
		border-bottom: 1px solid #eee;
	}

	.peridicalView>div:first-child {
		margin-top: 0px;
	}

	.peridicalViewTop {
		width: 70%;
		display: flex;
		justify-content: space-between;
		border-bottom: 1px solid #eee;
	}

	.first2 {
		margin: 30px 0px;
		font-size: 22px;
		padding-right: 50px;
		border-right: 2px solid #eee;
	}

	.first2:first-child {
		margin-left: 30px;
	}

	.first2:last-child {
		border-right: none;
	}

	.first0 {
		border-bottom: 1px solid #fff;
		font-size: 16px !important;
	}
</style>

<style scoped lang="scss">
	::v-deep .el-tabs--border-card>.el-tabs__content{
		min-height: 400px;
	}
</style>